import React, { ReactNode, useState, useEffect } from 'react';

import NavBar from '../../../pages/Home/NavBar.jsx';


import '../../../pages/Home/HomePage.css';
import '../../../pages/Home/index.css';

import koopWhite from '../../../assets/koop-public-logo-white.png';

interface PublicLayoutProps {
    children: ReactNode;
}


const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {

    return (
        <div className="homeContainer">
            <NavBar />


            {children}

            <div className="public-footer">
                <div className="container">
                    <div className="public-links">
                        <strong>Helpful Links</strong>
                        <a href="#faqs">FAQs</a>
                        <a href="#products">Products</a>
                        <a href="/privacypolicy">Privacy Policy</a>
                        <a href="/terms">Terms & Conditions</a>
                        <p>
                            Copyright © 2026<b>KOOP Batangan MPC</b>
                        </p>
                    </div>
                    <div className="public-logo">
                        <a href="/" className="public-footer-logo">
                            <img src={koopWhite} alt="KOOP Batangan Logo" />
                        </a>
                        <p>
                            Powered by <strong>DVIA Solutions</strong>
                        </p>
                    </div>
                </div>
            </div>

        </div>

    );

};

export default PublicLayout;